<fieldset class="panel panel-white padding-0">
    <div class="panel-heading border-light">
        <h4 class="panel-title">Order Invoicing</h4>
        <ul class="panel-heading-tabs border-light">
            <li class="d-flex">
                <div class="input-wrapper">
                    <i class="prefix fa-light fa-magnifying-glass"></i>
                    <input [value]="searchText()" (input)="handleSearchInput($event)" class="text-input" placeholder="Search" />
                    <button
                        id="job-invoices-cost-plus-filter-search-reset"
                        class="suffix btn-flat btn-small square"
                        (click)="searchText.set('')">
                        <i class="fa-light fa-xmark"></i>
                    </button>
                </div>
            </li>
            <li *ngIf="selectedOrders.length">
                <div class="btn-group">
                    <button type="button" class="btn btn-bx-primary" (click)="invoiceSelectedOrders()">
                        <i class="ti-plus"></i> Invoice {{ selectedOrders.length }} order(s)
                    </button>
                </div>
            </li>
            <li>
                <div class="btn-group dropdown" dropdown>
                    <button type="button" class="btn btn-default dropdown-toggle" dropdownToggle aria-haspopup="true" aria-expanded="false">
                        <i class="ti-settings"></i> <span class="caret margin-left-5"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right no-max-height" *dropdownMenu role="menu">
                        <li *ngIf="permissionService.getState('jobs.maintain-invoices.manage-payment-terms') | async">
                            <a id="view-terms-and-conditions" (click)="viewTermsAndConditions()"
                                ><i class="ti-comment-alt"></i> Manage Payment Terms</a
                            >
                        </li>
                        <li *ngIf="permissionService.getState('jobs.maintain-invoices.print-email-invoice-statement') | async">
                            <a id="print-invoice-statement" (click)="printJobClaim()"><i class="ti-printer"></i> Print Invoice Statement</a>
                        </li>
                        <li>
                            <a id="show-cost-plus-breakdown" (click)="toggleShowCostPlusItemisation()">
                                <i *ngIf="termsAndConditions.showCostPlusItemisation" class="ti-check"></i> Show cost plus breakdown
                            </a>
                        </li>
                        <li>
                            <a id="show-order-instructions" (click)="toggleShowOrderInstructions()">
                                <i *ngIf="termsAndConditions.showOrderInstructions" class="ti-check"></i> Show order instructions
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div class="panel-body">
        <div class="row">
            <div class="col-xs-12">
                <div class="btn-group btn-group-xs" role="group">
                    <button
                        id="job-invoices-cost-plus-status-all"
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'All' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('All')">
                        All <span class="badge badge-light-grey">{{ orderCounts().all }}</span>
                    </button>
                    <button
                        id="job-invoices-cost-plus-status-not-invoiced"
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'NotInvoiced' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('NotInvoiced')">
                        Not Invoiced <span class="badge badge-light-grey">{{ orderCounts().notInvoiced }}</span>
                    </button>
                    <button
                        id="job-invoices-cost-plus-status-pending"
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Pending' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Pending')">
                        Pending <span class="badge badge-light-grey">{{ orderCounts().pending }}</span>
                    </button>
                    <button
                        id="job-invoices-cost-plus-status-invoiced"
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Invoiced' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Invoiced')">
                        Invoiced <span class="badge badge-light-grey">{{ orderCounts().invoiced }}</span>
                    </button>
                    <button
                        id="job-invoices-cost-plus-status-part-received"
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'PartReceived' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('PartReceived')">
                        Part Received <span class="badge badge-light-grey">{{ orderCounts().partreceived }}</span>
                    </button>
                    <button
                        id="job-invoices-cost-plus-status-received"
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Received' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Received')">
                        Received <span class="badge badge-light-grey">{{ orderCounts().received }}</span>
                    </button>
                </div>
                <div class="form-group form-inline pull-right margin-right-5">
                    <label>Default due days:</label>
                    <input
                        legacy-css
                        class="form-control margin-left-5"
                        type="number"
                        min="0"
                        max="365"
                        required
                        [(ngModel)]="job.InvoiceDueDays"
                        (change)="saveJob()"
                        [ngModelOptions]="{ standalone: true }"
                        appNullReplace="14" />
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="table-wrapper">
                <ngx-datatable
                    [ngStyle]="{ height: tableHeight }"
                    #invoicesTable
                    class="material bxt-table"
                    [rows]="rows()"
                    [rowHeight]="40"
                    columnMode="force"
                    [scrollbarV]="true"
                    [headerHeight]="50"
                    [footerHeight]="0"
                    [virtualization]="false"
                    [sorts]="[{ prop: 'OrderNumber', dir: 'asc' }]"
                    [limit]="100">
                    <!-- columns -->
                    <ngx-datatable-column name="Select " [sortable]="false" [flexGrow]="1" [minWidth]="50">
                        <ng-template ngx-datatable-header-template>
                            <div *ngIf="hasUnpaidInvoices">
                                <app-bx-datatable-select-all-header
                                    checkBoxId="purchaseOrder"
                                    [allRowsSelected]="isAllOrderSelected"
                                    (toggleAllRowsSelected)="onToggleAllRowsSelected($event)">
                                </app-bx-datatable-select-all-header>
                            </div>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div
                                class="checkbox clip-check check-primary margin-top-0 margin-bottom-0 margin-left-5"
                                *ngIf="!row.ID_JobPayment">
                                <input
                                    legacy-css
                                    type="checkbox"
                                    [disabled]="row.ID_JobPayment"
                                    id="id{{ row.ID_PurchaseOrder }}"
                                    [(ngModel)]="row.selected"
                                    (ngModelChange)="selectedChanged(row)" />
                                <label for="id{{ row.ID_PurchaseOrder }}"></label>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Order #" [flexGrow]="1" [minWidth]="95" prop="OrderNumberString">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a class="bxt-row-action" (click)="viewOrder(row)">
                                {{ row.OrderNumberString }}
                                <i
                                    *ngIf="row.AccSyncData && row.AccSyncData !== 'blocked'"
                                    class="ti-cloud-up"
                                    tooltip="Synced to your accounting software"
                                    container="body"></i>
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Description" [flexGrow]="4" prop="Description">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a class="bxt-row-action" (click)="viewOrder(row)">
                                {{ row.Description }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Supplier" [flexGrow]="2" prop="SupplierDescription">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.SupplierDescription }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Total (Ex)" [flexGrow]="2" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.HasInvoices ? (row.InvoiceTotalExTax | bxCurrency) : (row.OrderTotalExTax | bxCurrency) }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Cost Plus %" [flexGrow]="2" prop="CostPlusPercentage">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.CostPlusPercentage | number: '1.2-2' }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Invoice #" [flexGrow]="1" [minWidth]="100" prop="JobPayment.InvoiceNumberString">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a class="bxt-row-action" *ngIf="row.ID_JobPayment" (click)="viewInvoice(row.JobPayment)">
                                {{ row.JobPayment.InvoiceNumberString }}
                                <i
                                    *ngIf="row.JobPayment.AccSyncData && row.JobPayment.AccSyncData !== 'blocked'"
                                    class="ti-cloud-up"
                                    tooltip="Synced to your accounting software"
                                    container="body"></i>
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Inv. Desc" [flexGrow]="3" prop="JobPayment.Description">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a class="bxt-row-action" *ngIf="row.ID_JobPayment" (click)="viewInvoice(row.JobPayment)">
                                {{ row.JobPayment.Description }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Inv. Status" [flexGrow]="2" [maxWidth]="100" prop="JobPayment.Status">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span
                                *ngIf="row.ID_JobPayment"
                                class="label"
                                [ngClass]="{
                                    'label-inverse': row.JobPayment.Status === 'Pending',
                                    'label-warning': row.JobPayment.Status === 'Invoiced',
                                    'label-info': row.JobPayment.Status === 'PartReceived',
                                    'label-success': row.JobPayment.Status === 'Received',
                                }"
                                >{{ row.JobPayment.Status }}</span
                            >
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                        [sortable]="false"
                        [flexGrow]="4"
                        [width]="185"
                        [canAutoResize]="false"
                        [draggable]="false"
                        [resizeable]="false"
                        [cellClass]="'right-align'"
                        [headerClass]="'disabled'">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button
                                type="button"
                                class="btn btn-xs btn-info margin-left-5"
                                (click)="addReceipt(row.JobPayment)"
                                tooltip="Add Payment Receipt"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="
                                    permissionService.isAvailable('jobs.maintain-invoices.add-payment-receipt') &&
                                    (row.JobPayment?.Status === 'Invoiced' || row.JobPayment?.Status === 'PartReceived')
                                ">
                                <i class="ti-receipt"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-default margin-left-5"
                                (click)="shareInvoice(row.JobPayment)"
                                tooltip="Share"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="row.JobPayment">
                                Share
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-default margin-left-5"
                                (click)="printInvoice(row.JobPayment)"
                                tooltip="Print"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="row.JobPayment && permissionService.isAvailable('jobs.maintain-invoices.print-email-invoice')">
                                <i class="ti-printer"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-danger margin-left-5 margin-right-5"
                                (click)="deleteOrderOrInvoice(row)"
                                tooltip="Delete"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="
                                    row.JobPayment?.Status === 'Pending' &&
                                    permissionService.isAvailable('jobs.maintain-invoices.delete-invoice')
                                ">
                                <i class="ti-trash"></i>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>
</fieldset>

<footer class="fixed-footer hidden-print" *ngIf="selectedOrders.length">
    <div class="footer-inner">
        <div class="row padding-10">
            <div class="col-xs-12 text-center">
                <button type="button" class="btn btn-bx-primary margin-left-5 margin-right-5" (click)="invoiceSelectedOrders()">
                    <i class="ti-plus"></i> Invoice {{ selectedOrders.length }} order(s)
                </button>
                <button
                    *ngIf="orderCounts().pending > 0"
                    type="button"
                    class="btn btn-bx-primary margin-left-5 margin-right-5"
                    (click)="attachOrderToInvoice()">
                    <i class="ti-plus"></i> Attach to existing invoice
                </button>
                <button type="button" class="btn btn-bx-secondary-stroked margin-left-5 margin-right-5" (click)="clearSelectedOrders()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</footer>
